import LoadingSpinner from './loading-spinner-view'

export default LoadingSpinner
